/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('ActivitiesBoard', ActivitiesBoard);

    ActivitiesBoard.$inject = ['$resource', 'DateUtils'];

    function ActivitiesBoard ($resource, DateUtils) {
        var resourceUrl =  'api/activities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.activitiesDate = DateUtils.convertLocalDateFromServer(data.activitiesDate);
                        data.validFrom = DateUtils.convertLocalDateFromServer(data.validFrom);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.activitiesDate = DateUtils.convertLocalDateToServer(copy.activitiesDate);
                    copy.validFrom = DateUtils.convertLocalDateToServer(copy.validFrom);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.activitiesDate = DateUtils.convertLocalDateToServer(copy.activitiesDate);
                    copy.validFrom = DateUtils.convertLocalDateToServer(copy.validFrom);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
